import { TeamNames } from './types';
export const TeamInfo = {
    [TeamNames.OCTOPUS]: {
        name: TeamNames.OCTOPUS,
        channel: 'ft-octopus'
    },
    [TeamNames.NEXUS]: {
        name: TeamNames.NEXUS,
        channel: 'ft-nexus'
    },
    [TeamNames.CWF]: {
        name: TeamNames.CWF,
        channel: 'cwf-partners'
    },
    [TeamNames.ECOMMERCE]: {
        name: TeamNames.ECOMMERCE,
        channel: 'ft-ecommerce'
    },
    [TeamNames.FLAPJACK]: {
        name: TeamNames.FLAPJACK,
        channel: 'ft-flapjack'
    },
    [TeamNames.PACMAN]: {
        name: TeamNames.PACMAN,
        channel: 'ft-pacman'
    },
    [TeamNames.ADS]: {
        name: TeamNames.ADS,
        channel: 'ft-ads'
    },
    [TeamNames.SEARCH]: {
        name: TeamNames.SEARCH,
        channel: 'ft-search'
    },
    [TeamNames.HACKWORTH]: {
        name: TeamNames.HACKWORTH,
        channel: 'ft-hackworth'
    },
    [TeamNames.GROWTH_A]: {
        name: TeamNames.GROWTH_A,
        channel: 'ft-growth'
    },
    [TeamNames.VERVE]: {
        name: TeamNames.VERVE,
        channel: 'verve-public'
    },
    [TeamNames.MANDALORIANS]: {
        name: TeamNames.MANDALORIANS,
        channel: 'ft-mandalorians'
    },
    [TeamNames.MYAC]: {
        name: TeamNames.MYAC,
        channel: 'ft-myaccount'
    },
    [TeamNames.TITANS]: {
        name: TeamNames.TITANS,
        channel: 'ft-titans'
    },
    [TeamNames.CW]: {
        name: TeamNames.CW,
        channel: 'ft-commerceweb'
    },
    [TeamNames.CMW]: {
        name: TeamNames.CMW,
        channel: 'ft-garuda'
    },
    [TeamNames.MEMBERSHIP]: {
        name: TeamNames.MEMBERSHIP,
        channel: 'gatekeepers-partners'
    },
    [TeamNames.WT]: {
        name: TeamNames.WT,
        channel: 'ft-rigel'
    },
    [TeamNames.NITEHAWK]: {
        name: TeamNames.NITEHAWK,
        channel: 'ft-nitehawk'
    },
    [TeamNames.VSE]: {
        name: TeamNames.VSE,
        channel: 'vse-public'
    },
    [TeamNames.CQNA]: {
        name: TeamNames.CQNA,
        channel: 'ft-coreqna'
    },
    [TeamNames.SAR]: {
        name: TeamNames.SAR,
        channel: 'ft-searchandrec'
    }
};
